import { createSlice } from "@reduxjs/toolkit";

export interface FavouriteDetailState {
  data: [] | null | any;
  totalRecords: number | null;
  totalPage: number | null;
}

const initialState: FavouriteDetailState = {
  data: null,
  totalRecords: null,
  totalPage: null,
};

export const favouriteSlice = createSlice({
  name: "favourite",
  initialState,
  reducers: {
    setFavouriteDetail: (state, action) => {
      state.data = action.payload && action.payload.data;
      state.totalRecords = action.payload && action.payload.totalRecords;
      state.totalPage = action.payload && action.payload.totalPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setFavouriteDetail, reset } = favouriteSlice.actions;

export const getFavouriteData = (state: any) => state.favourite.data;
export const getFavouriteTotalRecord = (state: any) =>
  state.favourite.totalRecords;
export const getFavouriteTotalPages = (state: any) => state.favourite.totalPage;

export default favouriteSlice.reducer;
